import React, { useEffect } from 'react';
import Table from '../../components/Table';
import { observer } from 'mobx-react-lite';
import Button from '../../components/Button';
import { useHistory } from 'react-router-dom';
import { FaSearch } from 'react-icons/fa';
import translations from '../../translations/de';
import ItemImage from '../../components/ItemImage';
import { FaPlus } from 'react-icons/fa';
import Paths from '../../constants/paths';
//import Select from '../../components/Select';

const Teams = ({ store }) => {
    const history = useHistory();
    //const [other, setOther] = useState(false);

    useEffect(() => {
        let params = {
            // other: other,
            league_enum: 'CHL',
        };
        store.getTeams(params);
    }, [store /*other,*/]);

    const handleTeam = (id) => {
        store.selectTeam(id);
        history.push(`/teams-chl/${id}`);
    };

    // const handleLeagueChange = (e) => {
    //     if (e.value === 'other') {
    //         setOther(true);
    //     } else {
    //         setOther(false);
    //     }
    // };
    return (
        <>
            <div style={{ marginLeft: '2.5%', display: 'flex', alignItems: 'center' }}>
                <Button
                    label={translations.team}
                    onClick={() => {
                        store.selectTeam(undefined);
                        history.push(Paths.NEW_TEAM_CHL);
                    }}
                    style={{ marginBottom: '15px', marginRight: '10px' }}
                >
                    <FaPlus style={{ marginRight: '5px' }} />
                </Button>
            </div>
            <Table
                isLoading={store.isLoading}
                tableName={translations.teams}
                columns={[
                    {
                        Header: 'ID',
                        accessor: 'id',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: translations.logo,
                        accessor: 'logo_url',
                        Cell: ({ value, row }) => (
                            <div>
                                <ItemImage imgSrc={value} alt="team" listView={true} />
                            </div>
                        ),
                    },
                    {
                        Header: translations.title,
                        accessor: 'title',
                        Cell: ({ value, row }) => <div>{value}</div>,
                    },
                    {
                        Header: '',
                        accessor: 'action',
                        Cell: ({ row }) => (
                            <div>
                                <Button
                                    onClick={() => {
                                        handleTeam(row.cells[0].value);
                                    }}
                                    title={translations.show}
                                >
                                    <FaSearch />
                                </Button>
                            </div>
                        ),
                    },
                ]}
                data={store.teams.map(({ id, logo_url, title }) => {
                    return {
                        id,
                        logo_url,
                        title,
                    };
                })}
            />
        </>
    );
};

export default observer(Teams);
